import {RockBottomParsedData} from "./RockBottomParsedData";
import {FeatureBuyData, IBetWinData, IRockBottomInitData, ISymbolValues} from "./IRockBottomData";
import {RockBottomDataParser} from "./RockBottomDataParser";

export class RockBottomParsedInitData extends RockBottomParsedData {

    public readonly betWins: IBetWinData[];
    public readonly symbolValues: ISymbolValues;
    public readonly isRestoreState: boolean;
    public readonly featureBuyTimesBetValue: FeatureBuyData[];
    public readonly collectedScatters: number;
    public readonly fsSymbolMultiplier: number[];
    public readonly symbolSizes: number[][];
    public readonly evaluatedArea: string[][];
    public readonly reelsEnteringFreespin: string[][];
    public readonly nudgeSteps: number[];
    public readonly enhancedBetPlayed: boolean;
    public readonly fsLevel: number;
    public readonly fsLevelNextSpin: number;

    constructor(rawData: IRockBottomInitData, parser: RockBottomDataParser) {
        console.log("INIT DATA", rawData);
        super(rawData, parser);

        this.betWins = parser.parseBetWins(rawData);
        this.symbolValues = rawData.symbolValues;
        this.isRestoreState = rawData.isRestoreState;
        this.featureBuyTimesBetValue = rawData.featureBuyTimesBetValue;
        this.collectedScatters = rawData.collectedScatters;
        this.fsSymbolMultiplier = rawData.fsSymbolMultiplier;
        this.symbolSizes = rawData.symbolSizes;
        this.evaluatedArea = rawData.evaluatedArea;
        this.reelsEnteringFreespin = rawData.reelsEnteringFreespin;
        this.nudgeSteps = parser.parseNudgeSteps(rawData);
        this.enhancedBetPlayed = rawData.enhancedBetPlayed;
        this.fsLevel = rawData.fsLevel;
        this.fsLevelNextSpin = rawData.fsLevelNextSpin ? rawData.fsLevelNextSpin : rawData.fsLevel;
    }
}